export default "__VITE_ASSET__BRt2xqQ7__"